import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getLicensesLocalStorageAction } from 'src/app/store/actions/licenses.actions';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HeaderService } from 'src/app/angular-core/services/header.service';
import { ShoppingBasketButtonComponent } from '../../components/shopping-basket-button/shopping-basket-button.component';
import { hasRoleUserData } from 'src/app/utils/functions/permission.function';
import { Roles } from 'src/app/utils/enums/roles';
import { filter } from 'rxjs/operators';
import { IUserData } from 'src/app/utils/interfaces/auth.interfaces';
import { selectUserData } from 'src/app/store/selectors/auth.selectors';
import { IPermission } from 'src/app/shared/guards/authorized.guard';
import { OperationEnum } from 'src/app/utils/enums/operation.enums';

@UntilDestroy()
@Component({
  selector: 'xpac-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LicensesComponent implements OnInit {

  private userData: IUserData = null;

  constructor(
    private headerService: HeaderService,
    private cdr: ChangeDetectorRef,
    private store: Store<IRemoteXPACPortalState>
  ) { }

  public ngOnInit(): void {
    this.initAuthInfo();
  }

  public agGetRequiredPermissions(): IPermission[] {
    return [
      { type: 'RemoteMaintenance.License', operation: OperationEnum.READ }
    ];
  }

  public ngOnDestroy(): void {
    this.headerService.resetHeaderButton();
  }

  public hasCrossPointRole(): boolean {
   
    return (hasRoleUserData(Roles.CrosspointAdmin, this.userData) || hasRoleUserData(Roles.Crosspoint, this.userData));
  }  

  private initAuthInfo(): void {
    this.store.select(selectUserData)
      .pipe(
        filter((value: IUserData | null) => value !== null),
        untilDestroyed(this)
      )
      .subscribe((userData: IUserData) => {
       this.userData = userData;
       this.initData();
       this.setHeaderButton();
      });
  }

  private setHeaderButton(): void {
    // only set the shoppingbasket if needed
    if (!this.hasCrossPointRole()) {
      this.headerService.setHeaderButton(ShoppingBasketButtonComponent);
    }
  }

  private initData(): void {
    // Refresh shopping basket from local storage if not Cross Point
    if(!this.hasCrossPointRole){
      this.store.dispatch(getLicensesLocalStorageAction());
    }    
  }
}